// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 45px;
}

th,
td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    font-weight: bold;
    font-size: 16px;
    font-family: sans-serif;
}

tr:hover {
    background-color: #f2f2f2;
}

.searchbar,
.dropdown,
.searc {
    border: 1px solid #efefef;
    height: 36px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 36px;
    padding: 0 10px;
}

.searchbar:hover,
.dropdown:hover,
.searc:hover {
    border-color: #ccc;
}

.buxx {
    margin-left: 854px;
    margin-top: -47px;
}

@media only screen and (max-width: 768px) {

    th,
    td {
        padding: 8px;
        font-size: 14px;
    }

    th {
        font-size: 14px;
    }

    h2 {
        font-size: 18px;
    }

    .bS {
        border-radius: 10px;
    }
    .searc {
        width: 200px;
    }
    .buxx {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        margin-top: 10px;
    }
} */
`, "",{"version":3,"sources":["webpack://./src/Css/Performance.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyEG","sourcesContent":["/* table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 45px;\r\n}\r\n\r\nth,\r\ntd {\r\n    padding: 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\nth {\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    font-family: sans-serif;\r\n}\r\n\r\ntr:hover {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.searchbar,\r\n.dropdown,\r\n.searc {\r\n    border: 1px solid #efefef;\r\n    height: 36px;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n    line-height: 36px;\r\n    padding: 0 10px;\r\n}\r\n\r\n.searchbar:hover,\r\n.dropdown:hover,\r\n.searc:hover {\r\n    border-color: #ccc;\r\n}\r\n\r\n.buxx {\r\n    margin-left: 854px;\r\n    margin-top: -47px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n\r\n    th,\r\n    td {\r\n        padding: 8px;\r\n        font-size: 14px;\r\n    }\r\n\r\n    th {\r\n        font-size: 14px;\r\n    }\r\n\r\n    h2 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .bS {\r\n        border-radius: 10px;\r\n    }\r\n    .searc {\r\n        width: 200px;\r\n    }\r\n    .buxx {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        text-align: center;\r\n        margin-top: 10px;\r\n    }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
